import React, { useState, useRef, useEffect } from 'react';
import { Send, Bot, User } from 'lucide-react';
import './fpllm.css';

const FootballChat = () => {
    const [messages, setMessages] = useState([
        {
            id: 1,
            text: "Hey there, coach! Ready to chat about anything on your mind? I'm here to help you tackle any questions!",
            sender: 'bot',
            timestamp: new Date()
        }
    ]);
    const [inputValue, setInputValue] = useState('');
    const [isTyping, setIsTyping] = useState(false);
    const messagesEndRef = useRef(null);
    const inputRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!inputValue.trim()) return;

        const userMessage = {
            id: Date.now(),
            text: inputValue,
            sender: 'user',
            timestamp: new Date()
        };

        setMessages(prev => [...prev, userMessage]);
        setInputValue('');
        setIsTyping(true);

        // Simulate API call with mock response
        setTimeout(() => {
            const botResponse = {
                id: Date.now() + 1,
                text: "That's a great question! While I'm just a demo component right now, in a real implementation I'd connect to your LLM backend to provide helpful responses. Ready for the next play?",
                sender: 'bot',
                timestamp: new Date()
            };
            setMessages(prev => [...prev, botResponse]);
            setIsTyping(false);
        }, 1500);
    };

    const formatTime = (date) => {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div className="fpllm">
            <div className="football-chat">
                {/* Header */}
                <div className="chat-header">
                    <div className="header-content">
                        <div className="football-icon"></div>
                        <div>
                            <h3 className="header-title">FPLLM</h3>
                            <p className="header-subtitle">Ready to tackle your questions!</p>
                        </div>
                    </div>
                </div>

                {/* Messages */}
                <div className="messages-container">
                    {messages.map((message) => (
                        <div key={message.id} className={`message ${message.sender}`}>
                            <div className="message-avatar">
                                {message.sender === 'bot' ? <Bot size={20} /> : <User size={20} />}
                            </div>
                            <div className="message-content">
                                <div className="message-bubble">
                                    {message.text}
                                </div>
                                <div className="message-time">
                                    {formatTime(message.timestamp)}
                                </div>
                            </div>
                        </div>
                    ))}

                    {isTyping && (
                        <div className="typing-indicator">
                            <div className="message-avatar" style={{background: 'linear-gradient(135deg, #ff6b35, #f7931e)'}}>
                                <Bot size={20} color="white" />
                            </div>
                            <div className="typing-bubble">
                                <div className="typing-dot"></div>
                                <div className="typing-dot"></div>
                                <div className="typing-dot"></div>
                            </div>
                        </div>
                    )}
                    <div ref={messagesEndRef} />
                </div>

                {/* Input */}
                <div className="input-container">
                    <div className="input-form">
                        <input
                            ref={inputRef}
                            type="text"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleSendMessage(e)}
                            placeholder="Ask me anything, coach..."
                            className="message-input"
                            disabled={isTyping}
                        />
                        <button
                            onClick={handleSendMessage}
                            className="send-button"
                            disabled={!inputValue.trim() || isTyping}
                        >
                            <Send size={20} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FootballChat;